import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { ClaimIntegrationControllerApi } from "../../../services"; 
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useClaimIntegrationArchive = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new ClaimIntegrationControllerApi(
      getConfigObject()
    ).updateClaimIntegrationArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID
    )
  );
